import { render, staticRenderFns } from "./NextProjects.vue?vue&type=template&id=e56552c6&scoped=true&"
import script from "./NextProjects.vue?vue&type=script&lang=js&"
export * from "./NextProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56552c6",
  null
  
)

export default component.exports